import React from 'react';
import Layout from '../components/Layout';
import { History } from 'lucide-react';
import LoginHistoryPanel from '../components/LoginHistoryPanel';

function LoginHistory() {
  return (
    <Layout>
      <div className="p-6 space-y-4">
        <h1 className="text-2xl font-bold flex items-center gap-2">
          <History className="w-6 h-6 text-purple-600" />
          Login History
        </h1>
        <LoginHistoryPanel />
      </div>
    </Layout>
  );
}

export default LoginHistory;
